"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenCartIcon =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenCartIcon, _React$Component);

  function FullscreenCartIcon(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasCartApi: false
    };
    _this.cartApi = null;

    _this.getcartApi();

    return _this;
  }

  var _proto = FullscreenCartIcon.prototype;

  _proto.getcartApi =
  /*#__PURE__*/
  function () {
    var _getcartApi = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      var _ref, cartApi;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('@wix/pro-gallery-artstore-statics'));
              });

            case 2:
              _ref = _context.sent;
              cartApi = _ref.cartApi;
              this.cartApi = cartApi;
              this.setState({
                hasCartApi: true
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getcartApi() {
      return _getcartApi.apply(this, arguments);
    }

    return getcartApi;
  }();

  _proto.render = function render() {
    var _this2 = this;

    var count = this.props.cartItemsCount > 0 ? _react["default"].createElement("span", null, this.props.cartItemsCount) : false;
    return _react["default"].createElement("span", {
      className: 'fullscreen-icon fullscreen-cart-icon has-custom-focus',
      onClick: function onClick() {
        return _this2.state.hasCartApi && _this2.cartApi.showCart();
      },
      "aria-label": "Cart",
      tabIndex: 0
    }, _react["default"].createElement("button", {
      tabIndex: -1
    }, _react["default"].createElement("svg", {
      viewBox: "0 0 18 16",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
      id: "a",
      d: "M0 4h18l-3.033 12H3z"
    }), _react["default"].createElement("mask", {
      id: "c",
      x: "0",
      y: "0",
      width: "18",
      height: "12",
      fill: "#fff"
    }, _react["default"].createElement("use", {
      xlinkHref: "#a"
    })), _react["default"].createElement("path", {
      d: "M14 5A5 5 0 0 0 4 5",
      id: "b"
    }), _react["default"].createElement("mask", {
      id: "d",
      x: "0",
      y: "0",
      width: "10",
      height: "10",
      fill: "#fff"
    }, _react["default"].createElement("use", {
      xlinkHref: "#b"
    }))), _react["default"].createElement("g", {
      strokeWidth: "2",
      stroke: "currentColor",
      fill: "none",
      fillRule: "evenodd"
    }, _react["default"].createElement("use", {
      mask: "url(#c)",
      xlinkHref: "#a"
    }), _react["default"].createElement("use", {
      mask: "url(#d)",
      xlinkHref: "#b"
    })))), count);
  };

  return FullscreenCartIcon;
}(_react["default"].Component);

var _default = FullscreenCartIcon;
exports["default"] = _default;